import { Checkbox } from '@monorepo/shared/componentsV2/Checkbox';
import { ComplianceCalendarEventType } from 'mapistry-shared';
import React from 'react';
import styled from 'styled-components';

const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 1rem;
`;

const EVENT_TYPE_FILTER_OPTIONS = [
  { type: ComplianceCalendarEventType.LOG, label: 'Log Events' },
  { type: ComplianceCalendarEventType.TASK, label: 'Tasks' },
  { type: ComplianceCalendarEventType.INSPECTION, label: 'Inspections' },
] as const;

interface EventTypeFilterPanelProps {
  eventTypes: ComplianceCalendarEventType[];
  onChange: (nextEventTypes: ComplianceCalendarEventType[]) => void;
}

function toggleEventType(
  eventTypes: ComplianceCalendarEventType[],
  type: ComplianceCalendarEventType,
): ComplianceCalendarEventType[] {
  return eventTypes.includes(type)
    ? eventTypes.filter((t) => t !== type)
    : [...eventTypes, type];
}

export function EventTypeFilterPanel({
  eventTypes,
  onChange,
}: EventTypeFilterPanelProps) {
  return (
    <Section>
      {EVENT_TYPE_FILTER_OPTIONS.map(({ type, label }) => (
        <Checkbox
          key={type}
          checked={eventTypes.includes(type)}
          label={label}
          onChange={() => onChange(toggleEventType(eventTypes, type))}
        />
      ))}
    </Section>
  );
}
